<x-chartist [type]="'Bar'" [data]="stackedBarData" [options]="stackedBarOptions" class="height-300">
</x-chartist>